import {RangeModel} from '../shared/range.model';
import {DropdownModel} from '../../component/dropdown.model';
import {QuestionExtendedModel} from '../question-extended.model';

export class FractionSetupFromImageModel extends QuestionExtendedModel {

  static MissingFactorTypes = {
    numerator: 'numerator',
    denominator: 'denominator',
    both: 'both',
    list: function() {
      return [this.numerator, this.denominator, this.both];
    },
    dropdownList: function () {

      const list = DropdownModel.generateFromKeys(this.list());

      return list;

    }
  };

  model = {
    numeratorRange: new RangeModel(),
    denominatorRange: new RangeModel(),
    missingFactor: FractionSetupFromImageModel.MissingFactorTypes.numerator
  };

  static generateModel(json: any): FractionSetupFromImageModel {

    const q = new FractionSetupFromImageModel();

    if (json.model.numeratorRange) {
      q.model.numeratorRange = RangeModel.generateModel(json.model.numeratorRange);
    }

    if (json.model.denominatorRange) {
      q.model.denominatorRange = RangeModel.generateModel(json.model.denominatorRange);
    }

    q.model.missingFactor = json.model.missingFactor;

    return q;

  }

}
